import { render, staticRenderFns } from "./invest-banner.vue?vue&type=template&id=58a5090d&scoped=true&"
import script from "./invest-banner.vue?vue&type=script&lang=js&"
export * from "./invest-banner.vue?vue&type=script&lang=js&"
import style0 from "./invest-banner.vue?vue&type=style&index=0&id=58a5090d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a5090d",
  null
  
)

export default component.exports